module.exports = __webpack_public_path__ + "img/group_avatar_guarantee_1.394b3d05.png";